import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { SLUG } from 'lib/queries';
import { client } from 'lib/sanity';

export const LANDING_PAGES_KEY = 'landingPages';

export interface LandingPageSlug {
  slug: string;
  isSkincarePath: boolean;
}

export const fetchLandingPages = async (): Promise<LandingPageSlug[]> => {
  const query = groq`
    *[ _type == 'timeline_landingPage']{
      ${SLUG},
      "isSkincarePath": coalesce(isSkincarePath, false)
    }
  `;

  const landingPages: LandingPageSlug[] = await client.fetch(query);
  return landingPages;
};

export const useLandingPages = () =>
  useQuery({ queryKey: [LANDING_PAGES_KEY], queryFn: fetchLandingPages });
